var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1866 5.75509L3.72888 2.06495M7.87291 0.742954L12.4856 3.37864C12.7681 3.54003 13.003 3.77326 13.1663 4.05468C13.3296 4.3361 13.4156 4.65571 13.4155 4.98109V9.29671C13.4156 9.62209 13.3296 9.94169 13.1663 10.2231C13.003 10.5045 12.7681 10.7378 12.4856 10.8992L7.87291 13.5348C7.59418 13.6941 7.27875 13.7778 6.95775 13.7778C6.63676 13.7778 6.32132 13.6941 6.0426 13.5348L1.42992 10.8992C1.14738 10.7378 0.912555 10.5045 0.749242 10.2231C0.58593 9.94169 0.499942 9.62209 0.5 9.29671V4.98109C0.499942 4.65571 0.58593 4.3361 0.749242 4.05468C0.912555 3.77326 1.14738 3.54003 1.42992 3.37864L6.0426 0.742954C6.32132 0.583742 6.63676 0.5 6.95775 0.5C7.27875 0.5 7.59418 0.583742 7.87291 0.742954Z",
    stroke: "#2866C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.961304 4.37207L6.08322 7.13045C6.35202 7.27515 6.65252 7.35089 6.95779 7.35089C7.26306 7.35089 7.56356 7.27515 7.83235 7.13045L12.9543 4.37207M6.95779 7.60095V13.5974",
    stroke: "#2866C2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.323935a14727b70b5c35fa031c10dee4.svg";
export { ForwardRef as ReactComponent };